import * as React from "react";
import NavBar from "../components/NavBar";
import { RouteChildrenProps } from "react-router";
import { Form, Modal, Pagination, Table, Button, ButtonToolbar } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import { firestore, storage } from "firebase";
import * as fs from "../firestore";
import AppUser from "../AppUser";
import firebase from "../firebase";
import DeviceListTable, { DeviceList, Warranty } from "../components/DeviceListTable";
import { StatusTypeIndexLabelMap } from "../DeviceTableLabel"
import "./DeviceListPage.css"
import { DownloadStatus } from "../DownloadStatus";
import moment from "moment";

const usersRef = firestore().collection(fs.Collection.Users);
const DeviceMastersRef = firestore().collection(fs.Collection.DeviceMasters);
const WarrantiesRef = firestore().collection(fs.Collection.Warranties);

function toBlob(base64: string, mimeType: string): Blob|null {
    const bin = atob(base64.replace(/^.*,/, ''));
    const buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }
    try {
        const blob = new Blob([buffer.buffer], { type: mimeType });
        return blob;
    } catch (e) {
        return null;
    }
}

interface Props extends RouteChildrenProps {
    user: AppUser,
    onsubmit: (deviceState: string) => void
}

interface State {
    id: string;
    serial: string;
    bluetooth: string;
    devStatus: string;
    errorMessage: string;
    showModal: boolean;
    popupModal: boolean;
    showDownloadModal: boolean;
    downloadStatus: DownloadStatus;
    downloadedCount: number;
    statusUpdate: boolean;
    DeviceList: DeviceList[];
    Warranty: Warranty[];
}

export default abstract class DeviceListPage extends React.Component<Props, State> {
    private onDeviceLinkClickedBound: (id: string, serial: string, bluetooth: string, devStatus: string) => void;
    private onChangeSerialBound: (ev: React.FormEvent<any>) => void;
    private onClickSearchBound: (ev: React.MouseEvent) => void;
    private onClickCloseModalBound: () => void;
    private onClickSaveStatusBound: () => void;
    private onSelectStatusBound: (eventKey: any, evt: Object) => any;
    private onClickPopupOKBound: () => void;
    private onClickDownloadOKBound: () => void;
    private onClickDownloadButtonBound: () => void;
    private onClickStartDownloadBound: () => void;
    private downloadTrigger: HTMLAnchorElement|null;

    constructor(props: Props) {
        super(props);
        this.onDeviceLinkClickedBound = this.onDeviceLinkClicked.bind(this);
        this.onChangeSerialBound = this.onChangeSerial.bind(this);
        this.onClickSearchBound = this.onClickSearch.bind(this);
        this.onClickCloseModalBound = this.onClickCloseModal.bind(this);
        this.onClickSaveStatusBound = this.onClickSaveStatus.bind(this);
        this.onSelectStatusBound = this.onSelectStatus.bind(this);
        this.onClickPopupOKBound = this.onClickPopupOK.bind(this);
        this.onClickDownloadOKBound = this.onClickDownloadOK.bind(this);
        this.onClickDownloadButtonBound = this.onClickDownloadButton.bind(this);
        this.onClickStartDownloadBound = this.onClickStartDownload.bind(this);
        this.downloadTrigger = null;

        this.state = {
            id: "",
            serial: "",
            bluetooth: "",
            devStatus: "",
            errorMessage: "",
            showModal: false,
            popupModal: false,
            statusUpdate: false,
            showDownloadModal: false,
            downloadStatus: DownloadStatus.None,
            downloadedCount: 0,
            DeviceList: [],
            Warranty: []
        };
    }

    abstract getPageTitle(): string;
    abstract makeFetchDeviceMastersQuery( reverseOrder: boolean): firestore.Query;
    abstract makeFetchDeviceMastersQueryForwardMatch( reverseOrder: boolean, startcode: string, endcode : string): firestore.Query;
    abstract makeFetchWarrantyQuery( ): firestore.Query;

    async componentDidMount() {
        const DeviceList = await this.fetchDeviceMaster();
        const Warranty = await this.fetchWarranty();
        this.setWarrantyStartDate( DeviceList, Warranty );
        this.setState({
           DeviceList
        });
    }

    async componentDidUpdate() {
        if (this.state.statusUpdate === false) return;
        this.setState({
            statusUpdate: false
        });
        try {
            const DeviceList = await this.fetchDeviceMasterForwardMatch();
            const Warranty = await this.fetchWarranty();
            this.setWarrantyStartDate( DeviceList, Warranty );
            this.setState({
                DeviceList
            });
        } catch (e) {
            this.setState({errorMessage: e.message});
        }
    }


    private async onDeviceLinkClicked(id: string, serial: string, bluetooth: string, devStatus: string) {
        this.setState({
            id: id,
            serial: serial,
            bluetooth: bluetooth,
            devStatus: devStatus,
            showModal: true
        });
    }

    onChangeSerial(ev: React.FormEvent<any>): void {
        const value: string = (ev.target as HTMLInputElement).value;
        this.setState({
            serial: value
        });
    }

    async onClickSearch(ev: React.MouseEvent): Promise<void> {
        ev.preventDefault();
        const serial = this.state.serial;
        if (serial === "") {
            try {
                const DeviceList = await this.fetchDeviceMaster();
                const Warranty = await this.fetchWarranty();
                this.setWarrantyStartDate( DeviceList, Warranty );
                this.setState({
                    DeviceList
                });
            } catch (e) {
                this.setState({errorMessage: e.message});
            }
        }
        else {
            try {
                const DeviceList = await this.fetchDeviceMasterForwardMatch();
                const Warranty = await this.fetchWarranty();
                this.setWarrantyStartDate( DeviceList, Warranty );
                this.setState({
                    DeviceList
                });
            } catch (e) {
                this.setState({errorMessage: e.message});
            }
        }

    }

    onClickCloseModal() {
        this.setState({
            showModal: false,
            statusUpdate: false
        });
    }

    async onClickSaveStatus() {
        const updateStat = await this.updateDeviceMaster();
        this.setState({
            showModal: false,
            popupModal: true
        });
    }

    onSelectStatus(eventKey: any, evt: Object): any {
        this.setState({
            devStatus: eventKey
        });
    }

    async updateDeviceMaster(): Promise<void> {
        const refID = this.state.id;
        const DeviceMasterUpdateRef = firestore().collection(fs.Collection.DeviceMasters).doc(refID);
        try {
            DeviceMasterUpdateRef
            .update({
                "Status": this.state.devStatus,
                "CreateDateTime": firebase.firestore.FieldValue.serverTimestamp(),
            });
        } catch (e) {
            this.setState({errorMessage: e.message});
        }
    }

    async fetchDeviceMaster(reverseOrder: boolean = false): Promise<DeviceList[]> {
        const query = this.makeFetchDeviceMastersQuery(reverseOrder);
        const rawDeviceList = (await query.get()).docs.map(doc => {
            const data = doc.data() as fs.DeviceList;
            return {id: doc.id, data};
        });
        return rawDeviceList.map(rawDeviceList => {
            return {
                id: rawDeviceList.id,
                warrantyStartDate: rawDeviceList.id,
                ...rawDeviceList.data
            };
        });
    }

    async fetchDeviceMasterForwardMatch(reverseOrder: boolean = false): Promise<DeviceList[]> {
        const startcode = this.state.serial;
        const strlength = startcode.length;
        const strFrontCode = startcode.slice(0, strlength - 1);
        const strEndCode = startcode.slice(strlength - 1, startcode.length);
        const endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
        const query = this.makeFetchDeviceMastersQueryForwardMatch( reverseOrder,startcode, endcode);
        const rawDeviceList = (await query.get()).docs.map(doc => {
            const data = doc.data() as fs.DeviceList;
            return {id: doc.id, data};
        });
        return rawDeviceList.map(rawDeviceList => {
            return {
                id: rawDeviceList.id,
                warrantyStartDate: rawDeviceList.id,
                ...rawDeviceList.data
            };
        });
    }

    async fetchWarranty(): Promise<Warranty[]> {
        const query = this.makeFetchWarrantyQuery();
        const rawWarranty = (await query.get()).docs.map(doc => {
            const data = doc.data() as fs.Warranty;
            return {data};
        });
        return rawWarranty.map(rawWarranty => {
            return {
                ...rawWarranty.data
            };
        });
    }

    setWarrantyStartDate( list: DeviceList[], warranty: Warranty[] ): void {
        list.forEach( function( valuel, indexl ) {
            list[indexl].warrantyStartDate  = "";
            warranty.forEach( function( valuew, indexw ) {
                if ( valuel.SerialNo === valuew.SerialNo ) {
                   list[indexl].warrantyStartDate  = moment(warranty[indexw].WarrantyStartDate.toDate()).format("YYYY年MM月DD日");
                }
            })
        })
    }

    onClickPopupOK() {
        this.setState({
            popupModal: false,
            statusUpdate: true
        });

    }

    onClickDownloadOK() {
        this.setState({
            popupModal: false,
            downloadStatus: DownloadStatus.None,
            showDownloadModal: false
        });

    }

    private onClickDownloadButton() {
        this.setState({
            popupModal: true,
            showDownloadModal: true
        });
    }

    private async onClickStartDownload() {
        try {
            this.setState({downloadStatus: DownloadStatus.Downloading});
            const d = await firebase.functions().httpsCallable('createDeviceListExcel')();
            if (!this.downloadTrigger) {
                this.setState({
                    popupModal: false,
                    downloadStatus: DownloadStatus.None,
                    showDownloadModal: false
                });
                alert("エラーが発生しました, Error: 1000");
                return;
            }
            const blob = toBlob(d.data.excelData, d.data.mimeType);
            if (!blob) {
                this.setState({
                    popupModal: false,
                    downloadStatus: DownloadStatus.None,
                    showDownloadModal: false
                });
                alert("エラーが発生しました, Error: 1001");
                return;
            }
            this.downloadTrigger.href = window.URL.createObjectURL(blob);
            this.downloadTrigger.download = d.data.filename;
            this.downloadTrigger.click();
            this.setState({
                downloadStatus: DownloadStatus.Completed,
                downloadedCount: d.data.Count,
            });
        } catch (e) {
            this.setState({
                popupModal: false,
                downloadStatus: DownloadStatus.None,
                showDownloadModal: false
            });
            console.error(e);
            alert("エラーが発生しました, Error: 1002");
        }
    }

    private renderPopupModal(): JSX.Element {
        
        const renderNoneBody = () => {
            return (
                <Modal.Body>
                    <p><a href="#" onClick={this.onClickStartDownloadBound}>{"ダウンロード開始"}</a></p>
                </Modal.Body>
            );
        };  
        const renderDownloadingBody = () => {
            return (
                <Modal.Body>
                    <p>{"ダウンロード中です"}</p> 
                </Modal.Body>
            );  
        };      
        const renderCompletedBody = () => {
            return (
                <Modal.Body>
                    <p>{"ダウンロードが完了しました"}</p>
                    <p>{"データ数: " + this.state.downloadedCount}</p>
                </Modal.Body>
            );  
        };
        const renderClosePopupFooter = () => {
            return (
                    <Button variant="primary" type="button" onClick={this.onClickPopupOKBound}>ＯＫ</Button>
            );  
        };
        const renderCloseDownloadFooter = () => {
            return (
                    <Button variant="primary" type="button" onClick={this.onClickDownloadOKBound}>閉じる</Button>
            );  
        };

        return (
            <Modal
                show={this.state.popupModal}
                onHide={() => {
                    this.setState({ popupModal: false})}
                }
                dialogClassName="modal-20w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {
                            this.state.showDownloadModal ?
                            "機器リストダウンロード" :
                            "更新完了しました"
                        }
                    </Modal.Title>
                </Modal.Header>
                { this.state.showDownloadModal === true &&
                    <Modal.Body>
                            {
                                this.state.downloadStatus === DownloadStatus.None ?  renderNoneBody() :
                                this.state.downloadStatus === DownloadStatus.Downloading ? renderDownloadingBody() :
                                this.state.downloadStatus === DownloadStatus.Completed ?  renderCompletedBody() :
                            null
                            }
                            <a href="#" ref={ref => this.downloadTrigger = ref}></a>
                    </Modal.Body>
                }
                <Modal.Footer>
                    {
                        this.state.showDownloadModal ?
                            this.state.downloadStatus === DownloadStatus.Downloading ?
                                null : renderCloseDownloadFooter()
                            : renderClosePopupFooter()
                    }
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        return (
            <div>
                <NavBar {...this.props} />
                <div className="device_main">
                    <Form className="form_control">
                        <Form.Group>
                            <Form.Label >シリアルナンバーで絞込み</Form.Label>
                            <Form.Control type="text" value={this.state.serial} onChange={this.onChangeSerialBound} />
                            <p className="text-center">
                                <Button variant="primary" type="submit" onClick={this.onClickSearchBound}>
                                        検索
                                </Button> 
                            </p>
                        </Form.Group>
                    </Form>
                </div>
                <div className="device_list">
                    <div>
                       <Button variant="primary" type="submit" onClick={this.onClickDownloadButtonBound}>機器リストダウンロード</Button>
                    </div>
                    <h2 className="device_title">{this.getPageTitle()}</h2>
                        <DeviceListTable
                            DeviceList={this.state.DeviceList}
                            onDeviceLinkClicked={this.onDeviceLinkClickedBound}
                        />
                </div>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({ showModal: false})}
                    dialogClassName="modal-60w"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            { "機器ステータスの更新" }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>シリアル番号</th>
                                    <th>Bluetoothアドレス</th>
                                    <th>ステータス</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{this.state.id}</td>
                                    <td>{this.state.serial}</td>
                                    <td>{this.state.bluetooth}</td>
                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="primary" id="dropdown-basic">
                                                {StatusTypeIndexLabelMap[this.state.devStatus]}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="0" onSelect={this.onSelectStatusBound}>0:未使用</Dropdown.Item>
                                                <Dropdown.Item eventKey="1" onSelect={this.onSelectStatusBound}>1:利用中</Dropdown.Item>
                                                <Dropdown.Item eventKey="2" onSelect={this.onSelectStatusBound}>2:デモ用</Dropdown.Item>
                                                <Dropdown.Item eventKey="9" onSelect={this.onSelectStatusBound}>9:返却</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonToolbar>
                            <Button variant="primary" type="button" onClick={this.onClickCloseModalBound}> 閉じる</Button>
                            <Button variant="primary" type="button" onClick={this.onClickSaveStatusBound}> 保存</Button>
                        </ButtonToolbar>
                    </Modal.Footer>
                </Modal>
                {this.renderPopupModal()}
            </div>
        );
    }
}

